var m = require('mithril');
var prop = require('mithril/stream');
var moment = require('moment');
var key = require('../libs/keybindings');
var Model = require('../libs/Model');
var loaders = require('../layout/components/loaders');
var modal = require('../layout/components/modal');
var {createTempSvgElement} = require('../maps/mapUtils');

var Level = Object.assign(Object.create(Model), require('../../../../models/locations/Level'));

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});

Level.editDialogue = function (record, parentRecord, options) {
  Model.initForm.call(Level, record)
  Level.form.parent(parentRecord['@rid']);
  if (record && record.geojson) {
    if (typeof record.geojson === 'object') {
      Level.form.geojson(JSON.stringify(record.geojson));
    } else {
      Level.form.geojson(record.geojson);
    }
  }
  
  Level.record = record ? record : undefined;

  var submit = function () {
    if (Level.form.svg()) {
      const svgElement = createTempSvgElement(Level.form.svg());
      const parentSvgElement = createTempSvgElement(parentRecord.svg);

      // Get the MetaInfo from the parent SVG
      const parentMetaInfo = parentSvgElement.querySelector("MetaInfo");

      // Clear existing MetaInfo if it exists
      const existingMetaInfo = svgElement.querySelector("MetaInfo");
      if (existingMetaInfo) {
          existingMetaInfo.remove();
      }

      // Clone the parent's MetaInfo and append it to the current SVG
      if (parentMetaInfo) {
          const clonedMetaInfo = parentMetaInfo.cloneNode(true);
          svgElement.appendChild(clonedMetaInfo);
      }

      // Serialize the SVG element back to a string
      let serializer = new XMLSerializer();
      let updatedSVGString = serializer.serializeToString(svgElement);
      
      // Update the form with the modified SVG
      Level.form.svg(updatedSVGString);
    }

    return Level.save()
    .then( response => {
      key.unbind('enter');
      modal.vm.close();
      options && options.submitCallback ? options.submitCallback() : '';
    })
  };

  var deleteLevel = function (){
    return Level.delete(Level.record)
    .then( response => {
      key.unbind('enter');
      options && options.submitCallback ? options.submitCallback() : '';
      modal.vm.close();
      m.redraw();
    })
  }

  var renderEditModal = function () {
    key.unbind('enter');
    key.setScope('modal');
    key('enter', 'modal', submit);

    modal.vm.title( Level.record ? 'Edit Level: ' : 'Add Level: ')
    modal.vm.body = Level.view,

    Level.record && options && options.delete ? 
      modal.vm.buttons([
        {
          label: "Delete",
          class: "dib red mr3 ",
          func: showDeleteConfirmation
        },
        {
          label: "Save",
          class: "dib",
          func: submit
        }
      ])
    :
      modal.vm.buttons([
        {
          label: "Save",
          class: "btn-good",
          func: submit
        }
      ]);
  };

  var showDeleteConfirmation = function () {
    key.unbind('enter');

    var confirmDelete = function () {
      return deleteLevel();
    };

    key('enter', 'modal', confirmDelete);
    modal.vm.title(`Delete ${Level.record && Level.record.name ? Level.record.name : 'Level'}?`);
    modal.vm.body = function () {
      return m('div', [
        m('p', 'Are you sure you want to delete this location?')
      ]);
    };
    modal.vm.buttons([
      {
        label: "Cancel",
        class: "dib mr2 ",
        func: function () {
          renderEditModal();
          modal.vm.open();
        }
      },
      {
        label: "Delete",
        class: "dib red ",
        func: confirmDelete
      }
    ]);
    modal.vm.open();
  };

  renderEditModal();
  var modelOptions={
    extrawidth:true
  }
  modal.vm.open(modelOptions);
}


Level.view = function () {
  return m('form', {role:'form'}, [
    Level.errorView(),
    m('label', 'Name:'),
    m('input.form-control.mb2', {
      type:'text',
      oninput: (ev) => Level.form.name(ev.target.value),
      value: Level.form.name(),
    }),
    m('label', 'Floor:'),
    m('input.form-control.mb2', {
      type:'number',
      oninput: (ev) => Level.form.floor(ev.target.value),
      value: Level.form.floor(),
    }),
    m('label', 'Default Map View:'),
    m('input.form-control.mb2', {
      type:'text',
      oninput: (ev) => Level.form.defaultMapView(ev.target.value),
      value: Level.form.defaultMapView(),
    }),
    Level.record ?
      m('div', [
        m('label', {for:'comment'}, 'GeoJson Data:'),
        m('textarea', {
          resize: 'none',
          rows:'5',
          cols:'40', 
          'box-sizing': 'border-box',
          placeholder:"Add GeoJson data here...",
          oninput: ev => Level.form.geojson(ev.target.value),
          value: Level.form.geojson()
        }),
        m('label', {for:'comment'}, 'Map SVG:'),
        m('textarea', {
          resize: 'none',
          rows:'5',
          cols:'40', 
          'box-sizing': 'border-box',
          placeholder:"Add Map SVG data here...",
          oninput: ev => Level.form.svg(ev.target.value),
          value: Level.form.svg()
        })
      ])
      : ''
  ])
}

module.exports = Level;
